import { SVGS } from '../assets';
import { PromotionTypes } from '../constants';

export const getPromotionDetails = (
  type: string,
  minQty?: number,
  freeQty?: number,
  promotion?: number
) => {
  switch (type) {
    case PromotionTypes.BUYXGETY:
      return {
        icon: SVGS.FreePromotionIcon,
        text: `Buy ${minQty} Get ${freeQty} Free`,
        textColor: 'text-purple',
      };
    case PromotionTypes.PRODUCT_DISCOUNT:
      return {
        icon: SVGS.PromotionDiscount,
        text: `${promotion}% Offer applied!`,
        textColor: 'text-green',
      };
    default:
      break;
  }

  return {
    text: 'Offer applied!',
    textColor: 'text-default',
  };
};
